import { FullscreenHelper } from '../../helpers/FullscreenHelper';
import { ViewerEventType } from '../../types/ViewerEvents.type';
import { ThemeType } from '../../types/theme.type';
import { DataTestLabel } from '../../types/data-test-label.type';
export class NavigationComponent {
    constructor(theme = ThemeType.LIGHT, themeFullscreen = ThemeType.DARK, hostElement, assetViewer) {
        this.theme = theme;
        this.themeFullscreen = themeFullscreen;
        this.hostElement = hostElement;
        this.assetViewer = assetViewer;
        this.prefix = 'sp-av';
        this.elementClassName = `${this.prefix}-navigation`;
        this.offTimeoutMs = 2000;
        this.isInteracting = false;
        this.onButtonPreviousClick = (event) => {
            this.previous();
        };
        this.onButtonNextClick = (event) => {
            this.next();
        };
        this.onPublicFocusChange = (event) => {
            this.update();
        };
        this.onFullscreenChange = (event) => {
            this.update();
        };
        this.onEnableNavigationOnlyWithinCurrentAssetViewerItem = (event) => {
            this.update();
        };
        this.onDisableNavigationOnlyWithinCurrentAssetViewerItem = (event) => {
            this.update();
        };
        this.next = () => {
            this.assetViewer.next();
        };
        this.previous = () => {
            this.assetViewer.previous();
        };
        this.on = () => {
            this.element.classList.remove(`${this.elementClassName}--off`);
        };
        this.off = () => {
            this.element.classList.add(`${this.elementClassName}--off`);
        };
        this.onDocumentMouseMove = () => {
            this.on();
            this.scheduleOff();
        };
        this.onHostMouseEnter = () => {
            this.isInteracting = true;
        };
        this.onHostMouseLeave = () => {
            this.isInteracting = false;
        };
    }
    addEventListeners() {
        this.assetViewer.eventBus.on(ViewerEventType.PublicFocusChange, this.onPublicFocusChange);
        this.assetViewer.eventBus.on(ViewerEventType.FullscreenChange, this.onFullscreenChange);
        this.assetViewer.eventBus.on(ViewerEventType.EnableNavigationOnlyWithinCurrentAssetViewerItem, this.onEnableNavigationOnlyWithinCurrentAssetViewerItem);
        this.assetViewer.eventBus.on(ViewerEventType.DisableNavigationOnlyWithinCurrentAssetViewerItem, this.onDisableNavigationOnlyWithinCurrentAssetViewerItem);
        this.buttonPreviousElement.addEventListener('click', this.onButtonPreviousClick);
        this.buttonNextElement.addEventListener('click', this.onButtonNextClick);
        this.hostElement.addEventListener('mouseenter', this.onHostMouseEnter);
        this.hostElement.addEventListener('mouseleave', this.onHostMouseLeave);
        document.addEventListener('mousemove', this.onDocumentMouseMove);
    }
    removeEventListeners() {
        this.assetViewer.eventBus.off(ViewerEventType.PublicFocusChange, this.onPublicFocusChange);
        this.assetViewer.eventBus.off(ViewerEventType.FullscreenChange, this.onFullscreenChange);
        this.assetViewer.eventBus.off(ViewerEventType.EnableNavigationOnlyWithinCurrentAssetViewerItem, this.onEnableNavigationOnlyWithinCurrentAssetViewerItem);
        this.assetViewer.eventBus.off(ViewerEventType.DisableNavigationOnlyWithinCurrentAssetViewerItem, this.onDisableNavigationOnlyWithinCurrentAssetViewerItem);
        this.buttonPreviousElement.removeEventListener('click', this.onButtonPreviousClick);
        this.buttonNextElement.removeEventListener('click', this.onButtonNextClick);
        this.hostElement.removeEventListener('mouseenter', this.onHostMouseEnter);
        this.hostElement.removeEventListener('mouseleave', this.onHostMouseLeave);
        document.removeEventListener('mousemove', this.onDocumentMouseMove);
    }
    update() {
        this.updateButtons();
        this.updateTheme();
    }
    updateButtons() {
        this.buttonPreviousElement.disabled = !this.assetViewer.canNavigateToPrevious();
        this.buttonNextElement.disabled = !this.assetViewer.canNavigateToNext();
    }
    updateTheme() {
        const theme = !FullscreenHelper.isFullscreen() ? this.theme : this.themeFullscreen;
        this.element.classList.remove(`${this.elementClassName}--theme-${ThemeType.DARK}`);
        this.element.classList.remove(`${this.elementClassName}--theme-${ThemeType.LIGHT}`);
        this.element.classList.add(`${this.elementClassName}--theme-${theme}`);
    }
    scheduleOff() {
        clearTimeout(this.offTimeout);
        this.offTimeout = setTimeout(() => {
            if (!this.isInteracting) {
                this.off();
            }
        }, this.offTimeoutMs);
    }
    render() {
        const svg = '<svg viewBox="0 0 20 20" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M5.81919054,17.9991455 C5.50362224,17.6905898 5.49755199,17.1847611 5.80562475,16.8687213 L12.5011939,10 L5.80562475,3.13127874 C5.49755199,2.81523899 5.50362224,2.30941029 5.81919054,2.00085462 L5.82006454,2.00000004 C5.82031761,1.9997526 5.82057084,1.99950532 5.82082423,1.99925822 C6.13672418,1.69119843 6.64254349,1.69755413 6.95060328,2.01345408 L14.1942638,9.44146664 C14.4972662,9.75218056 14.4972662,10.2478195 14.1942638,10.5585334 L6.95060328,17.986546 C6.95035617,17.9867994 6.9501089,17.9870526 6.94986145,17.9873057 C6.6413821,18.3027959 6.13555479,18.3084794 5.82006454,18 L5.81919054,17.9991455 Z"></path></svg>';
        this.element = document.createElement('div');
        this.element.classList.add(this.elementClassName);
        this.element.innerHTML = `
            <button data-id="buttonPrevious" data-test-label="${DataTestLabel.NavigationPrevious}" class="${this.elementClassName}__button ${this.elementClassName}__button--prev disabled">${svg}</button>
            <button data-id="buttonNext" data-test-label="${DataTestLabel.NavigationNext}"  class="${this.elementClassName}__button ${this.elementClassName}__button--next disabled">${svg}</button>`;
        this.hostElement.appendChild(this.element);
        this.buttonPreviousElement = this.element.querySelector(`[data-id='buttonPrevious']`);
        this.buttonNextElement = this.element.querySelector(`[data-id='buttonNext']`);
    }
    init() {
        this.render();
        this.addEventListeners();
        this.scheduleOff();
    }
    destroy() {
        this.removeEventListeners();
        clearTimeout(this.offTimeout);
        this.hostElement.removeChild(this.element);
        this.element = null;
    }
}
//# sourceMappingURL=navigation.component.js.map